"use client"
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { useEffect } from "react";

const useModalCloseOnBrowserButton = (
	modalOpen: boolean,
	onClose: () => void,
) => {
  let popStateListener: (() => void) | null = null;
  useEffect(() => {  
    if (isOpenInApp() && modalOpen) {
      popStateListener = () => {
        onClose();
        try {
          window.history?.replaceState({ modalRestored: true }, "");
        } catch (e) {}
      };
      if (window.history && !window.history.state?.modalOpen) {
        window.history.pushState({ modalOpen: true }, "");
      }
      window.addEventListener?.("popstate", popStateListener);
      return () => {
        if (popStateListener) {
          window.removeEventListener?.("popstate", popStateListener);
        }
      };
    }
  },[modalOpen])
};

export default useModalCloseOnBrowserButton;
